import React from 'react';

import { LogoView } from '../../../components/player-interface/LogoView';

export const PlayerInterface = ({ data, uid, ...props }) => {
  return <LogoView />;
};
